import React from "react";
import { Link } from "gatsby";
import useFooterData from "@staticQueries/footerQuery";
import { MasterDisclaimer, FooterLinkGroup } from "@global";
import { KontentLinkGroup } from "./FooterLinkGroup";
import { Container } from "@ui";
import LeadFormController from "@components/leadForm/LeadFormController";

const Footer = ({ dontUseLeadForm }: any) => {
  const data = useFooterData();
  return (
    <footer>
      {!dontUseLeadForm && (
        <div className="relative">
          <a className="absolute top-[-120px]" id="leadform"></a>
          <div className={` bg-warmWhite pb-[40px] pt-[30px]`}>
            <Container>
              <LeadFormController />
            </Container>
          </div>
          <div className="h-[5px] w-full bg-white"></div>
        </div>
      )}
      <div className="bg-armyGreen pb-7 pt-10">
        <Container>
          <Link to="/">
            <img
              src={data.logo.value[0].url}
              width={data.logo.value[0].width}
              height={data.logo.value[0].height}
              alt="easymoney logo"
              className="mb-8"
            />
          </Link>
          <div className="flex flex-col gap-9 lg:flex-row lg:gap-11">
            {data.links.value.map((group: KontentLinkGroup, idx: number) => (
              <FooterLinkGroup
                titleLink={group.elements.title_link}
                subLinks={group.elements.sub_links}
                key={idx}
              />
            ))}
          </div>
        </Container>
      </div>
      <MasterDisclaimer />
    </footer>
  );
};

export default Footer;
